"use strict";
exports.__esModule = true;
exports.DateUtil = exports.DateFormat = void 0;
var DateFormat;
(function (DateFormat) {
    DateFormat["String"] = "string";
    DateFormat["Date"] = "date";
})(DateFormat = exports.DateFormat || (exports.DateFormat = {}));
var removeTimeFromDateUTC = function (date) {
    if (date) {
        var dateElements = date.split('-');
        var year = parseInt(dateElements[0]);
        var month = parseInt(dateElements[1]) - 1;
        var day = parseInt(dateElements[2]);
        var utcDate = Date.UTC(year, month, day, 0, 0, 0, 0);
        return new Date(utcDate);
    }
};
var removeTimeFromDate = function (date) {
    if (date) {
        return new Date(date.setHours(23, 59, 59, 0));
    }
};
var formatDate = function (date) {
    var year = date.getFullYear();
    var month = date.getMonth();
    var day = date.getDate();
    return [year, month, day].join('-');
};
/*const addDaysToDate = (days: number, date: Date) => {
    const dateToFormat = DateUtil.formatDate(date);
    const extendedDate = removeTimeFromDate(date);
    extendedDate.setDate(extendedDate.getDate() + days);
    return extendedDate;
};*/
var addDaysToDate = function (days, date) {
    var extendedDate = removeTimeFromDate(new Date(date));
    extendedDate.setDate(extendedDate.getDate() + days);
    return extendedDate;
};
var getDateStringFromDate = function (date) {
    return date.toISOString().split('T')[0];
};
var getDatesRange = function (start, end, output) {
    var dateArray = [];
    while (start <= end) {
        var dateToAdd = output === DateFormat.String ? getDateStringFromDate(start) : start;
        dateArray.push(dateToAdd);
        start = addDaysToDate(1, start);
    }
    return dateArray;
};
var getAllPossibleStayPeriod = function (stayPeriod) {
    var results = [];
    var datesInString = getDatesRange(removeTimeFromDate(new Date(stayPeriod.arrivalDate)), removeTimeFromDate(new Date(stayPeriod.departureDate)), DateFormat.String);
    for (var i = 1; i < datesInString.length; i++) {
        results.push({ arrivalDate: datesInString[i - 1], departureDate: datesInString[i] });
    }
    return results;
};
var formatCalendarDate = function (date, language) {
    return Intl.DateTimeFormat(language, { day: 'numeric', month: 'short', timeZone: 'UTC' }).format(date);
};
exports.DateUtil = {
    getAllPossibleStayPeriod: getAllPossibleStayPeriod,
    addDaysToDate: addDaysToDate,
    getDateStringFromDate: getDateStringFromDate,
    getDatesRange: getDatesRange,
    removeTimeFromDate: removeTimeFromDate,
    formatCalendarDate: formatCalendarDate,
    formatDate: formatDate
};
//# sourceMappingURL=date.js.map